<template>
    <section class="max-w-sm mx-auto w-full">
        <form method="post" action="https://cartero.wemake.pe/process/ye90yndyge"
            class="gap-2 py-4">
            <h3 class="text-xl font-bold">
                Request a quote
            </h3>

            <div class="grid grid-cols-1 gap-2 relative z-10">
                <div class="">
                    <label class="form-label">Name</label>
                    <input v-model="name" type="text" name="name" class="form-input w-full"
                        placeholder="Your name...">
                </div>
                <div class="">
                    <label class="form-label">Phone</label>
                    <input v-model="phone" type="phone" name="phone" class="form-input w-full" placeholder="Your phone...">
                </div>

                <div class="">
                    <label class="form-label">Email</label>
                    <input v-model="email" type="email" name="email" class="form-input w-full" placeholder="Your Email">
                </div>

                <div class="">
                    <label class="form-label">ZipCode</label>
                    <input v-model="zipcode" type="text" name="zipcode" class="form-input w-full" placeholder="Your Email">
                </div>
            </div>
            <div class="flex gap-1 mt-4">
                <div class="font-light text-sm md:col-span-2">
                    <label class="form-label">Payment</label>
                    <div>Wire-transfer</div>
                </div>
                
            </div>

            <div class="mt-4">
                <p class="text-slate-500 font-semibold">Pick your preferred method</p>
                <div class="flex flex-col gap-2 mt-3">

                    <!-- send by whatsapp -->
                    <button @click="sendWhatsApp" type="button" class="btn btn-primary p-2 flex gap-4">
                        <img src="/img/icon--whatsapp.png" alt="WhatsApp" class="w-5 h-5">
                        WhatsApp
                    </button>

                    <!-- send by email -->
                    <button type="submit" class="btn btn-primary bg-blue-600 p-2 flex gap-4">
                        <!-- email icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                            <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                            <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
                        </svg>

                        Email
                    </button>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
export default {
    props: {
        categories: Array
    },
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            zipcode: ""
        };
    },
    methods: {
        sendWhatsApp() {
            let message = `Hi BIS, I'd like to make an order:\n\n`;
            message += `Name: ${this.name}\n`;
            message += `Phone: ${this.phone}\n`;
            message += `Email: ${this.email}\n`;
            message += `ZipCode: ${this.zipcode}\n\n`;
            
            message += `Products:\n`;
            let productIndex = 1;
            this.categories.forEach(category => {
                category.products.forEach(product => {
                });
            });

            const encodedMessage = encodeURIComponent(message);
            const whatsappURL = `https://wa.me/51999111222?text=${encodedMessage}`;
            window.open(whatsappURL, "_blank");
        },
        sendEmail() {
            if (this.isSending) return;
            this.isSending = true;

            let hash = "ye90yndyge"
            let url = "https://cartero.wemake.pe/process/" + hash

            let productsStr = "";

            let data = {
                name: this.name,
                phone: this.phone,
                email: this.email,
                zipcode: this.zipcode,
                products: productsStr,
            }

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(resp => {
                    console.log('Success:', resp);
                    // go to next step
                    this.step++;
                })
        },
    },
    mounted() {
    }   
};
</script>
